import { Popover, Box } from '@mui/material'
import { useState } from 'react'
import OptionsFilter from '../../Filter/OptionsFilter'
import { useAppTheme } from '@/theme/ThemeContext'

export type RowModalOption = { id: string | number; label: string }

interface RowModalProps {
  /** Text shown in the cell (the current option's label). */
  label?: string | null
  /** Icon shown in the cell next to the label. */
  Icon?: React.ComponentType | null
  /** Icon shown next to every option in the picker. */
  optionIcon?: React.ComponentType | null
  options: RowModalOption[]
  /** Called with the picked option's id (as a string). */
  onChange?: (id: string) => void
  disabled?: boolean
}

const RowModal = ({
  label,
  Icon = null,
  optionIcon = null,
  options,
  onChange,
  disabled = false,
}: RowModalProps) => {
  const { mode } = useAppTheme()
  const isDarkMode = mode === 'dark'
  const textColor = isDarkMode ? '#FFFFFF' : '#003F61'

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    if (disabled) return
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  // OptionsFilter reports the whole checked list; the picker starts empty on
  // every open, so the last entry is the option just clicked.
  const handleSelect = (values: string[]) => {
    const picked = values[values.length - 1]
    if (picked != null) onChange?.(picked)
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  return (
    <>
      <Box
        textAlign="right"
        onClick={handleOpen}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          color: textColor,
          fontFamily: 'Rubik',
          fontSize: '14px',
          fontStyle: 'normal',
          cursor: disabled ? 'default' : 'pointer',
        }}
      >
        {Icon && label ? <Icon /> : null}
        {label || (disabled ? '-' : 'בחירה')}
      </Box>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <OptionsFilter
          checkBox={false}
          Icon={optionIcon}
          options={options}
          onChange={handleSelect}
        />
      </Popover>
    </>
  )
}

export default RowModal
